/** Format an ISO date string into a readable locale string. */
export const formatDate = (dateString) => {
  if (!dateString) return "--";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "--";
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/** Badge styling for a news publication status. */
export const statusBadgeClass = (status) => {
  switch (String(status || "").toUpperCase()) {
    case "PUBLISHED":
      return "inline-flex items-center rounded-full bg-emerald-500 px-2.5 py-0.5 text-[11px] font-bold text-white";
    case "DRAFT":
      return "inline-flex items-center rounded-full bg-slate-200 px-2.5 py-0.5 text-[11px] font-bold text-slate-700";
    case "ARCHIVED":
      return "inline-flex items-center rounded-full bg-red-100 px-2.5 py-0.5 text-[11px] font-bold text-red-700";
    default:
      return "inline-flex items-center rounded-full bg-slate-200 px-2.5 py-0.5 text-[11px] font-bold text-slate-700";
  }
};

/**
 * Normalize the varying news payload keys into a stable set the UI renders.
 * The list may return `{ news: [...] }`, `{ items: [...] }`, `{ data: [...] }`
 * or a bare array. Each item may use snake_case (like `cover_image`).
 */
export const normalizeNewsKey = (input) => {
  const raw = Array.isArray(input) ? input : [];
  return raw.map((n) => ({
    ...n,
    id: n.id ?? n._id,
    title: n.title ?? "",
    content: n.content ?? "",
    categoryId:
      n.categoryId ??
      n.category_id ??
      (n.category && typeof n.category === "object" ? n.category.id : n.category) ??
      null,
    excerpt: n.excerpt ?? "",
    coverImage: n.coverImage ?? n.cover_image ?? n.image ?? null,
    coverImageAlt: n.coverImageAlt ?? n.cover_image_alt ?? "",
    status: n.status ?? (n.isPublished ? "PUBLISHED" : "DRAFT"),
    tags: Array.isArray(n.tags) ? n.tags : [],
    featured: Boolean(n.featured),
    seoTitle: n.seoTitle ?? n.seo_title ?? "",
    seoDescription: n.seoDescription ?? n.seo_description ?? "",
    publishAt: n.publishAt ?? n.publish_at ?? null,
    createdAt: n.createdAt ?? n.created_at ?? null,
    updatedAt: n.updatedAt ?? n.updated_at ?? null,
  }));
};

/** Build the payload body for create/edit from form state. */
export const buildNewsPayload = (form) => ({
  title: form.title,
  content: form.content,
  categoryId: form.categoryId || undefined,
  excerpt: form.excerpt,
  coverImage: form.coverImage || undefined,
  coverImageAlt: form.coverImageAlt,
  status: form.status,
  tags: form.tags,
  featured: Boolean(form.featured),
  seoTitle: form.seoTitle,
  seoDescription: form.seoDescription,
  publishAt: form.publishAt || undefined,
});
